import React, { useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import { Star } from '../../lib/lucide-proxy';
import { supabase } from '../../config/supabase';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

const ReviewModal = ({ isOpen, onClose, breweryId, onSuccess }) => {
  const { user } = useAuth();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
        toast.error('Faça login para avaliar');
        return;
    }
    setLoading(true);
    try {
        const { error } = await supabase
            .from('reviews')
            .insert([{
                user_id: user.id,
                brewery_id: breweryId,
                rating,
                comment
            }]);
        
        if (error) throw error;
        toast.success('Avaliação enviada!');
        onSuccess();
        onClose();
    } catch (error) {
        console.error(error);
        toast.error('Erro ao enviar avaliação');
    } finally {
        setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Avaliar Cervejaria">
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex justify-center space-x-2">
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        type="button"
                        onClick={() => setRating(star)}
                        className="focus:outline-none transform hover:scale-110 transition-transform"
                    >
                        <Star 
                            className={`w-10 h-10 ${star <= rating ? 'text-yellow-400 fill-current' : 'text-gray-200'}`} 
                        />
                    </button>
                ))}
            </div>
            
            <div>
                <label className="block text-sm font-medium text-dark-700 mb-2">Seu comentário</label>
                <textarea
                    className="input-field"
                    rows={4}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="O que você achou das cervejas e do atendimento?"
                    required
                />
            </div>

            <div className="flex justify-end space-x-3">
                <Button variant="secondary" onClick={onClose} type="button">Cancelar</Button>
                <Button variant="primary" type="submit" loading={loading}>Enviar Avaliação</Button>
            </div>
        </form>
    </Modal>
  );
};

export default ReviewModal;